export const APP_CFG = {
	NETWORK: import.meta.env.VITE_NETWORK,
	API_URL: import.meta.env.VITE_SUIGAR_API_URL,
	PACKAGE: import.meta.env.VITE_PACKAGE_ADDR,
	PACKAGE_2: import.meta.env.VITE_PACKAGE_2_ADDR,
	NFT_FACTORY: import.meta.env.VITE_NFT_FACTORY,
	COINFLIP_COINFLIPGAME_SUI_SUI: import.meta.env.VITE_COINFLIP_COINFLIPGAME_SUI_SUI,
	DICE_DICEGAME_SUI_SUI: import.meta.env.VITE_DICE_DICEGAME_SUI_SUI,
	PLINKO_PLINKOGAME_SUI_SUI: import.meta.env.VITE_PLINKO_PLINKOGAME_SUI_SUI,
	LIMBO_LIMBOGAME_SUI_SUI: import.meta.env.VITE_LIMBO_LIMBOGAME_SUI_SUI,
	HOUSE_HOUSE_SUI_SUI: import.meta.env.VITE_HOUSE_HOUSE_SUI_SUI,
	LOOTBOX_LOOTBOXGAME_SUI_SUI: import.meta.env.VITE_LOOTBOX_LOOTBOXGAME_SUI_SUI,
	GLOBAL_CHAT_CHATROOM: import.meta.env.VITE_GLOBAL_CHAT_CHATROOM,
	HOUSE_ADMINCAP: import.meta.env.VITE_HOUSE_ADMINCAP,

	REFEREE_TABLE: import.meta.env.VITE_REFEREE_TABLE,
	REFERRER_TABLE: import.meta.env.VITE_REFERRER_TABLE,

	// Suigar v2 configuration
	SUIGAR_PACKAGE_ID: import.meta.env.VITE_SUIGAR_PACKAGE_ID,
	UPGRADE_CAP_ID: import.meta.env.VITE_UPGRADE_CAP_ID,
	ADMIN_CAP_ID: import.meta.env.VITE_ADMIN_CAP_ID,
	SWEETHOUSE_ID: import.meta.env.VITE_SWEETHOUSE_ID,
	MANAGER_REGISTRY_ID: import.meta.env.VITE_MANAGER_REGISTRY_ID,
	COINFLIP_SETTINGS_ID: import.meta.env.VITE_COINFLIP_SETTINGS_ID,
	VIP_REGISTRY_ID: import.meta.env.VITE_VIP_REGISTRY_ID,
	REFERRAL_REGISTRY_ID: import.meta.env.VITE_REFERRAL_REGISTRY_ID,

	// Pyth price info objects
	SUI_PYTH_PRICE_INFO_OBJECT_ID: import.meta.env.VITE_SUI_PYTH_PRICE_INFO_OBJECT_ID,
	USDC_PYTH_PRICE_INFO_OBJECT_ID: import.meta.env.VITE_USDC_PYTH_PRICE_INFO_OBJECT_ID,

	GOOGLE_OAUTH_APP_CLIENT_ID: import.meta.env.VITE_GOOGLE_OAUTH_APP_CLIENT_ID,
	TWITCH_OAUTH_APP_CLIENT_ID: import.meta.env.VITE_TWITCH_OAUTH_APP_CLIENT_ID,

	ZKLOGIN_PROVER_URL: import.meta.env.VITE_ZKLOGIN_PROVER_URL,
	ENOKI_API_KEY: import.meta.env.VITE_ENOKI_API_KEY,
	MOONPAY_API_KEY: import.meta.env.VITE_MOONPAY_API_KEY,
	COINBASE_ONCHAINKIT_API_KEY: import.meta.env.VITE_COINBASE_ONCHAINKIT_API_KEY,
	COINBASE_CDP_PROJECT_ID: import.meta.env.VITE_COINBASE_CDP_PROJECT_ID,

	SUI_EXPLORER_URL: `https://${import.meta.env.VITE_NETWORK}.suivision.xyz/`,

	// Coin types per environment
	SUI_COIN_TYPE: import.meta.env.VITE_SUI_COIN_TYPE,
	USDC_COIN_TYPE: import.meta.env.VITE_USDC_COIN_TYPE,
	USDCFLOWX_COIN_TYPE: import.meta.env.VITE_USDCFLOWX_COIN_TYPE,
};

// Validate APP_CFG for undefined values
function validateAppConfig() {
	const undefinedEntries: string[] = [];

	for (const [key, value] of Object.entries(APP_CFG)) {
		if (value === undefined) {
			undefinedEntries.push(key);
		}
	}

	if (undefinedEntries.length > 0) {
		const errorMessage = `❌ Missing environment variables for APP_CFG entries: ${undefinedEntries.join(', ')}
		
Please check that the following environment variables are defined:
${undefinedEntries.map((key) => `  - VITE_${key.replace(/_/g, '_')}`).join('\n')}

Current environment: ${import.meta.env.VITE_NETWORK || 'undefined'}
Mode: ${import.meta.env.MODE || 'undefined'}`;

		console.error(errorMessage);
		throw new Error(`Missing required environment variables: ${undefinedEntries.join(', ')}`);
	}

	// console.log(`✅ All APP_CFG entries are properly defined for environment: ${APP_CFG.NETWORK}`);
}

// Run validation immediately when module is imported
validateAppConfig();

export { CAMPAIGN_CFG } from './campaign-config';
